// extracted by mini-css-extract-plugin
module.exports = {"loading":"widget-space--loading--1jmdB","loadingMessage":"widget-space--loadingMessage--3QFIm","logo":"widget-space--logo--18GE6","spinner":"widget-space--spinner--3kNnH"};